import {axios, API, SendRequest, toastr, WebsiteCookies} from '@/imports-files/pages/admins/dashboard/clients/new';

export class Client extends SendRequest {
  async createClient(params) 
  {
    try {
      const result = await axios.post(API.admins.dashboard.clients.company.CREATE,
          params,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
      
    } catch (error) 
    {
      return error;
    }
  }

  async updateClient(params, clientId) {
    try {
      const result = await axios.patch(API.admins.dashboard.clients.company.UPDATE.replace('$client_id', clientId),
          params,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }
}
